import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SelectDialogAction {
	label: string;
	value: any;
	styleClass?: string;
	highlighted?: boolean;
	disabled?: boolean;
}

export interface SelectDialogData {
	title: string;
	message: string;
	actions: SelectDialogAction[];
	showCancel: boolean;
	cancelLabel: string;
	cancelHighlighted?: boolean;
	// Legacy confirm dialog support
	isConfirm?: boolean;
}

@Component({
	selector: 'ws-select-dialog',
	templateUrl: './select-dialog.component.html',
	styleUrls: ['./select-dialog.component.scss'],
})
export class SelectDialogComponent implements OnInit {
	title: string;
	message: string;
	actions: SelectDialogAction[];
	showCancel: boolean;
	cancelLabel: string;
	cancelHighlighted: boolean;
	isConfirm: boolean;

	constructor(
		public dialogRef: MatDialogRef<SelectDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data: SelectDialogData
	) {
		this.title = data.title;
		this.message = data.message;
		this.actions = data.actions || [];
		this.showCancel = data.showCancel ?? true;
		this.cancelLabel = data.cancelLabel;
		this.cancelHighlighted = data.cancelHighlighted ?? true;
		this.isConfirm = data.isConfirm ?? false;
	}

	ngOnInit(): void {}

	onActionClick(value: any, disabled?: boolean) {
		if (disabled) return;
		this.dialogRef.close(value);
	}

	onCancel() {
		this.dialogRef.close(null);
	}
}
